import { CSSProperties, HTMLAttributes } from 'react';
import { IconType } from '@src/types/IconType';
import { classNames } from '@utils/classNames';

export function Icon({
  type,
  className,
  maskSize,
  maskPosition,
  ...props
}: Readonly<
  {
    type: IconType;
    maskSize?: string;
    maskPosition?: string;
  } & HTMLAttributes<HTMLDivElement>
>) {
  const fullClassName = classNames(`icon`, className);

  const style = {
    ...props.style,
    '--icon-file-url': `url('/icons/${type}.svg')`,
    '--icon-mask-size': maskSize,
    '--icon-mask-position': maskPosition,
  };

  return (
    <div
      {...props}
      className={fullClassName}
      style={style as CSSProperties}
    ></div>
  );
}
